import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from "@mui/styles";
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import { API_ROOT } from '../../../../baseUrls'
import SearchResult from './SearchResult'

const styles = theme => ({
  textField: {
    marginRight: 8,
  },
  searchResultContainer: {
    overflow: 'scroll',
  },
})

class FindFriends extends Component {
  state = {
    searchName: '',
    searchCity: '',
    searchState: '',
    searchCountry: '',
    result: [],
  }

  search() {
    let url = new URL(`${ API_ROOT }/search-friend`)
    const params = {
      'find_mindfile[name]': this.state.searchName,
      'find_mindfile[location][locality]': this.state.searchCity,
      'find_mindfile[location][region]': this.state.searchState,
      'find_mindfile[location][country]': this.state.searchCountry,
      searcher_mindfile_id: this.props.mindfile.id,
    }
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
    fetch(url, {
      method: 'GET',
      credentials: 'include',
    })
    .then((resp) => {
      resp.json().then((result) => {
        this.setState({ result })
      })
      .catch((error) => {
        console.error(error)
      })
    })
    .catch((error) => {
      console.error(error)
    })
  }
  
  handleTextFieldKeyDown(event) {
    if (event.which === 13 || event.keyCode === 13) {
      this.search()
    }
  }

  render() {
    const { classes } = this.props
    return (
      <Box>
        <Accordion defaultExpanded={ true }>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h1>Find a LifeNaut</h1>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{marginTop:-20}}>
              <TextField
                id="name"
                label="Name"
                className={classes.textField}
                value={ this.state.searchName }
                onChange={ (e) => { this.setState({ searchName: e.target.value }) } }
                margin="normal"
                variant="outlined"
                onKeyDown={ this.handleTextFieldKeyDown.bind(this) }
              />
              <TextField
                id="city"
                label="City"
                className={classes.textField}
                value={ this.state.searchCity }
                onChange={ (e) => { this.setState({ searchCity: e.target.value }) } }
                margin="normal"
                variant="outlined"
                onKeyDown={ this.handleTextFieldKeyDown.bind(this) }
              />
              <TextField
                id="state"
                label="State"
                className={classes.textField}
                value={ this.state.searchState }
                onChange={ (e) => { this.setState({ searchState: e.target.value }) } }
                margin="normal"
                variant="outlined"
                onKeyDown={ this.handleTextFieldKeyDown.bind(this) }
              />
              <TextField
                id="country"
                label="Country"
                className={classes.textField}
                value={ this.state.searchCountry }
                onChange={ (e) => { this.setState({ searchCountry: e.target.value }) } }
                margin="normal"
                variant="outlined"
                onKeyDown={ this.handleTextFieldKeyDown.bind(this) }
              />
              <Box style={{ marginTop: 8 }}>
                <Button variant="contained" color="primary" onClick={ this.search.bind(this) }>Search</Button>
              </Box>
            </div>
          </AccordionDetails>
        </Accordion>
        <Box className={ classes.searchResultContainer }>
          <SearchResult users={ this.state.result } refresh={ this.search.bind(this) } />
        </Box>
      </Box>
    )
  }
}

const styledFindFriends = withStyles(styles)(FindFriends)

const mapStateToProps = (state) => {
  return {
    mindfile: state.mindfile,
  }
}

export default connect(mapStateToProps)(styledFindFriends)
